<template>
  <div class="table-wrap">
    <slot name="tabs" v-if="tabLocation == 'top'"></slot>
    <!-- 标题插槽 -->
    <slot name="title"></slot>
    <!-- tab切换 -->
    <slot name="tabs" v-if="tabLocation == 'center'"></slot>
    <div class="table-option" v-if="$slots['table-option'] || leadOut">
      <slot name="table-option"></slot>
      <slot name="confirm"></slot>
      <!-- 导出按钮 -->
      <LeadOut2
        class="leaout"
        v-if="leadOut && author == 'liuqiang'"
        :params="params"
        :column="column"
        :api="leadApi"
        :channelFlag="channelFlag"
      />
      <LeadOut
        class="leaout"
        v-else-if="leadOut && author == 'tanhao'"
        :params="params"
        :paramsType="paramsType"
        :column="childList ? childColumn : column"
        :api="leadApi"
        :channelFlag="channelFlag"
        :leadoutList="leadoutList"
        :videoFlag="videoFlag"
      />
      <LeadOutNew
        :column="childList ? childColumn : column"
        v-else-if="leadOut && author == 'new'"
        class="leaout"
        @click="leadOutClick"
      ></LeadOutNew>
    </div>
    <!-- tab切换 -->
    <slot name="tabs" v-if="tabLocation == 'bottom'"></slot>
    <!-- 表格的类型使用默认配置 -->
    <template v-if="tableType == 'default'">
      <!-- :height="Tableheight" -->
      <el-table
        :data="data"
        :max-height="maxHeight"
        style="width: 100%"
        size="small"
        v-loading="loading"
        ref="table"
        :default-sort="newDefaultSort"
        border
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
        @sort-change="onSortChange"
        :key="!keyFlag ? '' : num"
        @header-dragend="headerDragend"
        :size="tableSize"
        :class="widthFlag ? 'has-gutter' : ''"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeys"
        :row-style="rowStyle"
      >
        <!-- 此处新增了:row-key="getRowKeys" -->
        <el-table-column
          label="视频"
          v-if="PropStr && data.length"
          width="300"
          :prop="PropStr"
          align="center"
          :fixed="leftFlag"
        >
          <template slot-scope="scope">
            <div
              class="videoBox"
              v-if="scope.row.video != '总计' && scope.row.video != '均值'"
            >
              <!-- 磁力引擎 -->
              <div>
                <img
                  :src="
                    scope.row.cover_url
                      ? scope.row.cover_url
                      : require('@/asset/img/video_info.jpg')
                  "
                  class="video_img"
                  alt=""
                  style="cursor: pointer"
                  @click="openDialog(scope.row)"
                  v-if="scope.row.material_url || params.platform == 1"
                />
                <img
                  :src="
                    scope.row.cover_url
                      ? scope.row.cover_url
                      : require('@/asset/img/video_node.png')
                  "
                  class="video_img"
                  alt=""
                  v-else
                />
              </div>
              <div style="padding: 0 20px">
                <div>ID:{{ scope.row.material_id }}</div>
                <div>名称:{{ scope.row.filename }}</div>
                <div v-if="scope.row.material_create_time">
                  素材创建时间:{{ scope.row.material_create_time }}
                </div>
                <el-button
                  type="text"
                  @click="sourceInfo(scope.row)"
                  v-if="infoFlag === 1"
                  >素材详情</el-button
                >
              </div>
            </div>
            <div v-else>{{ scope.row.video }}</div>
          </template>
        </el-table-column>
        <!-- 多选按钮 -->
        <!-- 此处新增了一个:reserve-selection="true"配合el-table的:row-key="getOwnKeys使用" -->
        <!-- <el-table-column v-if="selection" type="selection" :reserve-selection="true" > </el-table-column> -->
        <!-- 表头 -->
        <el-table-column
          v-if="selection"
          type="selection"
          :reserve-selection="true"
          :selectable="selectNable"
          fixed
        >
        </el-table-column>
        <el-table-column
          v-for="(item, item_index) in column"
          :key="item_index"
          :prop="item.prop"
          :label="item.label"
          :fixed="item.fixed || false"
          :span-method="onSpanOption"
          :sortable="item.sortable || false"
          :align="alignStyle"
          :width="
            item.width
              ? item.width
              : widthFlag
              ? flexWidth(item.prop, data, item.label, item.sortable)
              : ''
          "
          :render-header="item.useSlotHeader ? null : headSpanFit"
          :show-overflow-tooltip="tooltipFlag || item.tooltipFlag"
          class-name="myUseSlot"
        >
          <!-- 自定义头部，目前只有提示文案自定义 -->
          <template #header="scope">
            {{ item.label }}
            <el-tooltip
              v-if="item.useSlotHeader"
              class="tool_tip_item"
              effect="dark"
              :content="item.desc"
              placement="top-start"
            >
              <i class="el-icon-info"></i>
            </el-tooltip>
          </template>
          <template #default="scope">
            <slot :name="item.prop" :row="scope.row">{{ scope.row[item.prop] }}</slot>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 使用多级表头 -->
    <template v-else-if="tableType == 'multilLevelHeader'">
      <!-- :height="Tableheight" -->
      <el-table
        :data="data"
        :max-height="maxHeight"
        style="width: 100%"
        ref="table"
        v-loading="loading"
        :default-sort="newDefaultSort"
        @sort-change="onSortChange"
        @header-dragend="headerDragend"
        @selection-change="handleSelectionChange"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column
          :width="k.width ? k.width : 120"
          :label="k.label"
          v-for="(k, k_idx) in column"
          :key="k_idx"
          align="center"
          :fixed="k.fixed || false"
          :prop="k.prop"
          :sortable="k.sortable"
        >
          <el-table-column
            :width="c.width ? c.width : 120"
            :prop="c.prop"
            v-for="(c, c_idx) in k.children ? k.children : []"
            :key="c_idx"
            :label="c.label"
            align="center"
            :sortable="c.sortable || false"
            :render-header="headSpanFit"
          >
          </el-table-column>
        </el-table-column>
      </el-table>
    </template>
    <!-- 分页 -->
    <div class="table-footer">
      <el-pagination
        background
        :layout="layout"
        :total="total"
        :current-page="currentPage"
        @current-change="onPageChange"
        @size-change="handleSizeChange"
        v-if="tablePagination == 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
      ></el-pagination>
      <el-pagination
        v-else
        background
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        :current-page="currentPage"
        @current-change="onPageChange"
        @size-change="handleSizeChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import LeadOut from "@/component/lead-out";
import LeadOut2 from "@/component/lead-out/index2";
import LeadOutNew from "@/component/lead-out/index_new";
export default {
  name: "tableLayout",
  data() {
    return {
      newDefaultSort: {},
      num: 10086,
      scrollLeft: null,
      maxHeight: 900, // 表格的最大高度
    };
  },
  components: {
    LeadOut,
    LeadOut2,
    LeadOutNew,
  },
  mounted() {
    this.scroll();
    // 计算屏幕高度
    this.getWinHeight();
  },
  beforeDestroy() {
    //页面销毁移除监听事件
    this.destroyScroll();
  },
  props: {
    infoFlag: {
      type: Number,
    },
    data: {
      type: Array,
    },
    column: {
      type: Array,
    },
    childColumn: {
      type: Array,
    },
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    tabLocation: {
      type: String,
      default: "bottom",
    },
    tablePagination: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
    },
    leadoutList: {
      type: Boolean,
      default: false,
    },
    leadOut: {
      type: Boolean,
    },
    params: {
      type: Object,
    },
    cellStyle: {
      type: Function,
    },
    headerCellStyle: {
      type: Function,
    },
    leadApi: {
      type: String,
    },
    layout: {
      type: String,
      default: "total,sizes, prev, pager, next, jumper",
    },
    alignStyle: {
      type: String,
      default: "center",
    },
    tooltipFlag: {
      type: Boolean,
      default: false,
    },
    PropStr: {
      type: String,
      default: "",
    },
    channelFlag: {
      type: Boolean,
      default: false,
    },
    videoFlag: {
      type: Boolean,
      default: false,
    },
    // 固定列【视频】的控制
    leftFlag: {
      type: [String, Boolean],
      default: "",
    },
    author: {
      type: String,
      default: "tanhao", // 后端开发人员
    },
    tableType: {
      // table表格的样式，default表示默认，multilLevelHeader 表示多级表头
      type: String,
      default: "default",
    },
    childList: {
      //true为多级表格，false为单级表格
      type: Boolean,
      default: false,
    },
    paramsType: {
      type: Number,
      default: 0,
    },
    //默认排序
    defaultSort: {
      type: Object,
      default: () => ({}),
    },
    // 表格整体样式
    tableSize: {
      type: String,
      default: "mini",
    },
    // 宽度
    widthFlag: {
      type: Boolean,
      default: false,
    },
    // 表格多选
    selection: {
      type: String,
      default: "",
    },
    // 强制刷新标识
    keyFlag: {
      type: Boolean,
      default: true,
    },
    // 每行样式
    rowStyle: {
      typeof: Object,
    },
    // 判断多选禁用的函数,从组件传过来
    selection_field: {
      type: Function,
      default: () => () => {},
    },
    // 固定表格的高度
    Tableheight: {
      type: String,
      default: "",
    },
  },
  methods: {
    // 计算屏幕高度
    getWinHeight() {
      this.maxHeight = document.body.clientHeight - 200;
    },
    // 点击导出
    leadOutClick(callBack) {
      this.$emit("leadOutClick", callBack);
    },
    scroll() {
      this.$refs.table.bodyWrapper.addEventListener("scroll", (e) => {
        this.scrollLeft = e.target.scrollLeft;
      });
    },
    destroyScroll() {
      this.$refs.table.bodyWrapper.removeEventListener("scroll", (e) => {
        this.scrollLeft = e.target.scrollLeft;
      });
    },
    Tablechange() {
      console.log(1);
    },
    doLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    // 表头拖拽
    headerDragend(newWidth, oldWidth, column, event) {
      const idx = this.column.findIndex((el) => el.label == column.label);
      if (idx > -1) {
        this.$set(this.column[idx], "width", newWidth);
      }
    },
    onPageChange(current) {
      this.$emit("pageChange", current);
    },
    handleSizeChange(current) {
      this.$emit("sizeChange", current);
    },
    onSpanOption(obj) {
      this.$emit("spanOption", obj);
    },
    onSortChange(data) {
      this.$emit("sortChange", data);
    },
    sourceInfo(data) {
      this.$emit("changeSourceInfo", data);
    },
    headSpanFit(h, { column, index }) {
      let labelLong = column.label ? column.label.length : 1; // 表头label长度
      let size = 14; // 根据需要定义标尺，直接使用字体大小确定就行，也可以根据需要定义
      column.minWidth = labelLong * size + 46; // 根据label长度计算该表头最终宽度
      return h("span", { class: "cell-content", style: { width: "100%" } }, [
        column.label,
      ]);
    },
    async openDialog(data) {
      if (this.params.platform == 5) {
        window.open(data.material_url);
      } else {
        this.$emit("videoUrlClick", { data, type: "openDialog" });
      }
    },
    // 自定义宽度
    flexWidth(prop, tableData, title, sortable = "") {
      if (tableData.length === 0) {
        //表格没数据不做处理
        return;
      }
      let flexWidth = 0; //初始化表格列宽
      let columnContent = ""; //占位最宽的内容
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      context.font = "14px Microsoft YaHei";
      if (prop === "" && title) {
        //标题长内容少的，取标题的值,
        columnContent = title;
      } else {
        // 获取该列中占位最宽的内容
        let index = 0;
        for (let i = 0; i < tableData.length; i++) {
          const now_temp = tableData[i][prop] + "";
          const max_temp = tableData[index][prop] + "";
          const now_temp_w = context.measureText(now_temp).width;
          const max_temp_w = context.measureText(max_temp).width;
          if (now_temp_w > max_temp_w) {
            index = i;
          }
        }
        columnContent = tableData[index][prop];
        //比较占位最宽的值跟标题、标题为空的留出四个位置
        const column_w = context.measureText(columnContent).width;
        const title_w = context.measureText(title).width;
        if (column_w < title_w) {
          columnContent = title || "留四个字";
        }
      }

      // 计算最宽内容的列宽
      let width = context.measureText(columnContent);
      if (sortable) {
        flexWidth = width.width + 50;
      } else {
        flexWidth = width.width + 20;
      }
      return flexWidth + "px";
    },
    // 表格多选的回调函数
    handleSelectionChange(data) {
      //向父组件传递拿到的数据
      this.$emit("handleChange", data);
    },
    //表格分页多选功能
    getRowKeys(row) {
      return row.id;
    },
    // 是否允许多选
    selectable(row, index) {
      if (
        row.trade_no.length == row.ostr.length &&
        row.ostr.length == 1 &&
        row.trade_no.length == 1
      ) {
        return true;
      }
    },
    selectNable(row) {
      return this.selection_field(row);
      // if(row.is_ack == 0){
      //   return true
      // }else{
      //   return false
      // }
    },
  },
  watch: {
    defaultSort: {
      handler: function (cur, old) {
        let order;
        if (cur.order === "asc") {
          order = "ascending";
        } else if (cur.order === "desc") {
          order = "descending";
        }
        // 需要查询当前排序字段是否有前缀字段，原因是后端针对排序字段可能要求的是bo.date这种格式，并不是原始的prop，这一步的目的是为了把前缀字段去掉，在table组件中能够高亮
        let index = cur.prop && cur.prop.indexOf("bo");
        let _prop = cur.prop;
        index > -1 && cur.prop && (_prop = cur.prop.split(".")[1]);
        this.newDefaultSort = JSON.parse(JSON.stringify({ prop: _prop, order }));
        this.num += 1;
        this.$nextTick(() => {
          setTimeout(() => {
            let scroll = this.$el.querySelector(".el-table__body-wrapper");
            scroll.scrollLeft = this.scrollLeft;
            this.scroll();
          }, 100);
        });
      },
      deep: true, //对象内部的属性监听，也叫深度监听
      immediate: true,
    },
    data: {
      handler: function (val) {
        this.num += 1;
        this.$nextTick(() => {
          setTimeout(() => {
            let scroll = this.$el.querySelector(".el-table__body-wrapper");
            scroll.scrollLeft = this.scrollLeft;
            this.scroll();
          }, 100);
        });
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  margin-top: 10px;

  .table-option {
    background-color: #fff;
    padding: 10px;
    display: flex;
    align-items: center;

    // position: relative;
    .leaout {
      /* position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%); */
      margin-left: 10px;
    }
  }

  .table-footer {
    display: flex;
    flex-direction: row-reverse;
    background-color: #fff;
    padding: 20px;
  }

  .videoBox {
    display: flex;
  }

  .video_img {
    width: 100px;
    height: 100px;
  }

  /deep/.has-gutter {
    color: #606266;
  }
}

.tool_tip_item {
  position: absolute;
  top: 0;
  right: 10px;
}
</style>
